/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FormValidator from '../../../../utilities/formValidator';
import './confirm-signup.scss';
import useIsDesktop from '../../../../utilities/hooks/useIsDesktop';
import GlobalError from '../../../shared/blocks/global-error/global-error';
import PrimaryButton from '../../../shared/buttons/primary-button/primary-button';
import ConfirmationCodeInput from '../../../shared/inputs/confirmation-code-input/confirmation-code-input';

const ResetPassword = () => {
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [emailVerificationResent, setEmailVerificationResent] = useState(false);
  const navigate = useNavigate();
  const formValidator = FormValidator();

  const queryParams = new URLSearchParams(window.location.search);
  const verify = queryParams?.get('verify');

  useEffect(() => {
    if (verify) {
      setConfirmationCode(verify);
    }
  }, [verify]);

  const resendVerificationEmail = async () => {
    try {
      const validateForm = formValidator.formValidate();
      const result = await Auth.resendSignUp(validateForm.email);
      if (result) {
        setUserEmail(validateForm.email);
        setEmailVerificationResent(true);
      }
    } catch (err) {
      formValidator.errorHandling(err);
    }
  };

  const onSubmitVerifcation = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const validateForm = formValidator.formValidate();
      setUserEmail(validateForm.email);
      const result = await Auth.confirmSignUp(
        validateForm.email,
        confirmationCode,
      );
      if (result) {
        setIsLoading(false);
        navigate('/login?verified=true');
      }
    } catch (error) {
      formValidator.errorHandling(error);
      setIsLoading(false);
    }
  };

  return (
    <div className="confirm-signup-page bg-white c-light-midnight p-x-content mw-s lh-150 m-b-48">
      <div className={`${isDesktop ? 'full-border' : ''}`}>
        <div>
          <div className="m-b-s">
            <h2 className="ff-wallop c-purple-primary fs-h4 lh-110">
              Verify your account
            </h2>
          </div>
          {emailVerificationResent && (
            <div className="user-not-confirmed-resent-box fs-p3 bg-neutral-purple c-purple-primary m-b-s">
              <p className="ff-graphik fs-p2 fw-normal">
                We have sent another verification code to
                <span className="ff-graphik fw-medium verification-email-span">
                  {userEmail}
                </span>
                . It may take a few minutes.
              </p>
            </div>
          )}
          <GlobalError>
            <p className="c-utility-red fs-p2">
              There was an issue while trying to verify your account. Please try
              again later or call our customer service representatives at
              <a
                className="c-utility-red td-underline td-none phone-number-link m-r-8"
                href="tel:18888488456"
              >
                888-848-8456
              </a>
            </p>
          </GlobalError>
          <div className="modal-body m-b-xs">
            <p className="ff-graphik fw-normal please-reset-text fs-p2">
              Please enter your verification code and email address below.
            </p>
            <form
              className="d-flex-column m-t-16"
              onSubmit={onSubmitVerifcation}
            >
              <div
                className="form-input m-b-xs"
                aria-labelledby="expiredCodeError"
              >
                <ConfirmationCodeInput
                  defaultValue={verify}
                  length={6}
                  placeholder=" "
                  onChange={setConfirmationCode}
                  autoFocus
                />
                <div
                  className="m-t-8 error warn jsExpiredCodeErrorExtra jsExpiredCodeExceptionExtra d-none"
                  id="expiredCodeError"
                />
              </div>
              <div className="form-input m-b-xs">
                <label
                  className="fs-p3 ff-graphik m-b-8"
                  htmlFor="email"
                  aria-required="true"
                  aria-labelledby="emailError"
                >
                  Email
                </label>
                <input
                  className="input form-control__input"
                  id="email"
                  name="email"
                  type="email"
                  required
                />
                <div
                  className="m-t-8 error warn jsAuthErrorEmailExtra jsEmailExceptionExtra jsInvalidParameterEmailExceptionExtra d-none"
                  id="emailError"
                />
              </div>
              <div className="mw-100 m-b-s">
                <PrimaryButton
                  onClick={onSubmitVerifcation}
                  fullWidth
                  isLoading={isLoading}
                  title="Verify Account"
                  buttonType="submit"
                />
              </div>
            </form>
            <div className="m-b-sm">
              <p className="ff-graphik c-light-midnight fs-p2 fw-normal ta-center">
                Didn't receive a code or code expired?
                <button
                  className="m-l-5 link ff-graphik-medium fw-normal accent c-purple-medium td-underline fs-p2"
                  onClick={resendVerificationEmail}
                  type="button"
                >
                  Resend verification
                </button>
              </p>
            </div>
            <p className="ff-graphik-medium fw-normal fs-p2 need-help">
              Need more help?
            </p>
            <div className="ff-graphik fs-p2 lh-24 customer-care-link m-t-4">
              If you're still having difficulty logging into your account,
              please call our customer service representatives at
              <a
                className="c-light-midnight td-underline td-none phone-number-link m-r-8"
                href="tel:18888488456"
              >
                888-848-8456
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
